import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';

import Button from '../../Button';
import Paragraph from '../../Paragraph';
import Heading from '../../Heading';
import { Row } from '../Scaffold';
import { renderField } from '../../Inputs';
import Progress from '../../Progress';

const required = value => (value || typeof value === 'number' ? undefined : 'Required');
const number = value => (value && isNaN(Number(value)) ? 'Must be a number' : undefined);

const parsers = {
  number: (value) => {
    let result;
    if (new RegExp(/^\d*$/g).test(value) && !(value.indexOf('.') > -1) && value.length > 3) {
      result = parseInt(value.substring(0, 3), 10) <= 999 ? value.substring(0, 3) : '';
    }

    if (value) {
      return new RegExp(/^(?!0+$)\d{1,3}$/g).test(value) ? value : result;
    }
    return '';
  },
};

const aboveOne = (value) => {
  if (value < 0) {
    return 0;
  } else if (value > 999) {
    return parseInt(value.toString().substr(0, 3), 0);
  }
  return value;
};


class Smoking extends React.PureComponent {
  state = {
    smoking: '',
    smokingAmount: '',
    smokingType: ''
  };

  componentDidMount() {
    if (window.pageYOffset > this.sectionRef.offsetTop) {
      window.scrollTo({ top: this.sectionRef.offsetTop, behavior: 'smooth' });
    }
  }

  render() {
    const { previousPage, handleSubmit } = this.props;
    return (
      <Row classes="smoking-less" setRef={(sectionRef) => { this.sectionRef = sectionRef; }}>
        <Progress step="smoking" />
        <Paragraph classes="images" center>
          <img src="https://livewelldorset.s3.amazonaws.com/Pathways/quitsmoking-roundal.png" alt="" width="100" height="100" />
        </Paragraph>
        <Heading classes="header-text red" center><span id="register7">Stop smoking</span></Heading>
        <Paragraph classes="width-limited" center>
          Quitting smoking is one of the hardest things to do but it is also one of the most important things you can to for your health.
        </Paragraph>

        <form onSubmit={handleSubmit} className="form-register">
          <Paragraph classes="section-text" center><strong>Do you currently smoke?</strong></Paragraph>
          <Field
            name="assessment[smoking]"
            type="radiogroup"
            params={{ dataKey: 'contact', name: 'assessment[smoking]', classes: 'red textUppercase' }}
            validate={[required]}
            component={renderField}
            centered
            onChange={(ks, smoking) => this.setState({ smoking })}
          />

          {this.state.smoking === 'Yes' || this.props.smoking === 'Yes' ? (
            <div>
              <Paragraph classes="section-text" center><strong>What do you smoke?</strong></Paragraph>
              <Field
                name="assessment[smoking_type_id]"
                type="radiogroup"
                validate={[required]}
                params={{ dataKey: 'SmokingType', name: 'assessment[smoking_type_id]', classes: 'red threeInRow' }}
                centered
                component={renderField}
                onChange={(ks, smokingType) => this.setState({ smokingType })}
              />

              <Paragraph classes="section-text smoking-day-section" center><strong>How many do you smoke a day?</strong></Paragraph>
              <Field
                name="assessment[smoking_quantity]"
                validate={[required, number]}
                type="text"
                centered
                component={renderField}
                normalize={aboveOne}
                parse={parsers.number}
                classes="text-input-field"
                onChange={(ks, smokingAmount) => this.setState({ smokingAmount })}
              />

              <Paragraph classes="section-text" center><strong>Would you like help to stop smoking?</strong></Paragraph>
              <Field
                name="pathway_smoking"
                validate={[required]}
                type="radiogroup"
                centered
                params={{ dataKey: 'LeaveMessage', name: 'pathway_smoking', classes: 'red textUppercase' }}
                component={renderField}

              />
            </div>
          ) : null}

          <Paragraph classes="button-groups divideline" center>
            <Button classes={['color-button red']} label="Next" onClick={handleSubmit} />
            <Button classes={['underline-button']} label="Back" onClick={previousPage} />
          </Paragraph>
        </form>
      </Row>
    );
  }
}

Smoking.propTypes = {
  previousPage: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  smoking: PropTypes.string.isRequired,
  smokingType: PropTypes.string.isRequired,
  smokingAmount: PropTypes.string.isRequired,
};

export default reduxForm({
  form: 'registration', // <------ same form name
  destroyOnUnmount: false, // <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
})(Smoking);



// WEBPACK FOOTER //
// ./src/Components/Register/FormPages/Smoking.jsx